import BackgroundImage from './BackgroundImage.jsx';

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/BackgroundImage/index.js